<template>
  <v-container
    class="onboarding-copy-code"
    align-center
    justify-center
    
  >
    <page-title title="Publish"></page-title>
    <!-- <Tabs :settings="tabSettings"></Tabs> -->
    <CopyCode :campaign="$store.getters['user/currentCampaign']"> </CopyCode>
  </v-container>
</template>

<script>
import CopyCode from '@/components/survey/CopyCode'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  name: 'ScriptCopy',
  components: {
    CopyCode,
    Tabs
  },
  computed: {
    tabSettings: function() {
      const tabs = []
      tabs.push({
        id: routes.SCRIPT_COPY,
        label: 'Copy Script'
      })
      return {
        preselected: null,
        tabs: tabs
      }
    }
  },
  methods: {}
}
</script>

<style lang="stylus">
  .onboarding-copy-code {
    position relative
    }
</style>
